import type { IsoTimestamp, IsoDate } from "./isoTypes";

/** Matches a calendar date "YYYY-MM-DD" with no time component. */
export const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

/** True if the value is a date-only "YYYY-MM-DD" calendar date (no time). */
export const isIsoDateOnly = (value: IsoTimestamp | IsoDate): boolean => ISO_DATE_RE.test(value);

/**
 * Convert a value to a Date for Intl formatting:
 * - date-only "YYYY-MM-DD" → local noon (calendar-stable regardless of runtime tz)
 * - otherwise → the raw instant (new Date(value))
 */
export const toIntlDate = (value: IsoTimestamp | IsoDate): Date => {
  if (ISO_DATE_RE.test(value)) {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day, 12, 0, 0);
  }
  return new Date(value);
};
